import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Base = styled.div`
  text-align: left;
  a {
    cursor: pointer;
    height: 17.5px;
    width: 17.5px;
    margin-left: 66px;
    &:first-child {
      margin-left: 0;
    }
  }
  a:visited {
    color: #dee6eb !important;
  }
`;

const Desktop = styled(Base)``;

const Mobile = styled(Base)`
  margin: 20px 0;
  a {
    margin-left: 24px;
    &:first-child {
      margin-left: 0;
    }
  }
`;

class SocialMedia extends Component {
  render() {
    return (
      <span>
        {this.props.isMobile ? (
          <Mobile>
            <a href="https://www.facebook.com/solvhealth">
              <img src="/images/icons/social/Icon-Facebook.svg" type="social" alt="fb" />
            </a>
            <a href="https://twitter.com/solvhealth">
              <img src="/images/icons/social/Icon-Twitter.svg" type="social" alt="twitter" />
            </a>
            <a href="https://www.instagram.com/solvhealth">
              <img type="social" alt="instagram" src="/images/icons/social/Icon-Instagram.svg" />
            </a>
          </Mobile>
        ) : (
          <Desktop>
            <a href="https://www.facebook.com/solvhealth">
              <img src="/images/icons/social/Icon-Facebook.svg" type="social" alt="fb" />
            </a>
            <a href="https://twitter.com/solvhealth">
              <img src="/images/icons/social/Icon-Twitter.svg" type="social" alt="twitter" />
            </a>
            <a href="https://www.instagram.com/solvhealth">
              <img type="social" alt="instagram" src="/images/icons/social/Icon-Instagram.svg" />
            </a>
          </Desktop>
        )}
      </span>
    );
  }
}

SocialMedia.propTypes = {
  isMobile: PropTypes.bool,
};

export default SocialMedia;
